<div class="chart-section">
  <div class="section-header">
    <div class="section-icon demography">
      <i class="bi bi-people"></i>
    </div>
    <h2 class="section-title">Audience Demographics</h2>
  </div>

  <div class="section-card">
    <app-progress [type]="typeProgress"></app-progress>

    <!-- Tabs -->
    <div class="section-tabs" *ngIf="+type() === 1">
      <button class="tab" [class.active]="typeFollower === 1" (click)="setType(1)">
        <i class="bi bi-people"></i> Total followers
      </button>
      <button class="tab" [class.active]="typeFollower === 3" (click)="setType(3)">
        <i class="bi bi-person-check"></i> Quality followers
        <a class="info-tip" data-tooltip="Demographics analysis of quality followers">
          <i class="bi bi-info-circle"></i>
        </a>
      </button>
    </div>

    <!-- Loading -->
    <app-loader *ngIf="!(profileState | async).loader['audit']['audienceStat']" size="sm" message="Analyzing demographics..."></app-loader>

    <div [class.dimmed]="!(profileState | async).loader['audit']['audienceStat']">
      <div class="chart-grid">
        <!-- Gender -->
        <div class="chart-cell" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.gender] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''" *ngIf="chartsAudience !== undefined">
          <app-audit-example [name]="sectionName.gender">
            <div class="chart-cell-header">
              <h3>
                <i class="bi bi-gender-ambiguous cell-icon text-purple"></i>
                Gender
                <a class="info-tip" data-tooltip="Sex - followers' analysis"><i class="bi bi-info-circle"></i></a>
              </h3>
            </div>
            <div class="chart-with-legend">
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.gender"></app-audit-placeholder>
              <div class="chart-pie-area">
                <div [chart]="chartsAudience[0]"></div>
              </div>
              <div class="chart-legend-area">
                <app-pie-legend [data]="chartsAudience[0]"></app-pie-legend>
              </div>
            </div>
          </app-audit-example>
        </div>

        <!-- Age -->
        <div class="chart-cell" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.age] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''" *ngIf="chartsAudience !== undefined">
          <app-audit-example [name]="sectionName.age">
            <div class="chart-cell-header">
              <h3>
                <i class="bi bi-calendar-heart cell-icon text-coral"></i>
                Age
                <a class="info-tip" data-tooltip="Age - followers' age"><i class="bi bi-info-circle"></i></a>
              </h3>
            </div>
            <div>
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.age"></app-audit-placeholder>
              <div [chart]="chartsAudience[1]"></div>
            </div>
          </app-audit-example>
        </div>

        <!-- Language -->
        <div class="chart-cell" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.language] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''" *ngIf="chartsAudience !== undefined">
          <app-audit-example [name]="sectionName.language">
            <div class="chart-cell-header">
              <h3>
                <i class="bi bi-translate cell-icon text-blue"></i>
                Language
                <a class="info-tip" data-tooltip="The dominant language spoken by followers"><i class="bi bi-info-circle"></i></a>
              </h3>
            </div>
            <div>
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.language"></app-audit-placeholder>
              <div [chart]="chartsAudience[2]"></div>
            </div>
          </app-audit-example>
        </div>

        <!-- Interests -->
        <div class="chart-cell" [ngClass]="!(profileState | async).boxExampleStatus[sectionName.interest] && !((profileState | async).audit !== null && (profileState | async).audit.status) ? 'sample-chart' : ''" *ngIf="chartsInterest !== undefined">
          <app-audit-example [name]="sectionName.interest">
            <div class="chart-cell-header">
              <h3>
                <i class="bi bi-heart cell-icon text-red"></i>
                Interests
                <a class="info-tip" data-tooltip="Interests (based on followers activity for example used hashtags)"><i class="bi bi-info-circle"></i></a>
              </h3>
            </div>
            <div>
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.interest"></app-audit-placeholder>
              <div [chart]="chartsInterest[0]"></div>
            </div>
          </app-audit-example>
        </div>
      </div>
    </div>
  </div>
</div>